import MH_Navbar_Logo from '../images/mh-white.svg';
export default function Navbar() {
    return (
        <div id = "navbar" style = {{display: 'flex', justifyContent: 'space-between', padding: '20px', backgroundColor: 'black'}}>
            <a href = ""><img src = {MH_Navbar_Logo}></img></a>
            <div style = {{display: 'flex', gap: '20px'}}>
                <a href = "https://missouri.qualtrics.com/jfe/form/SV_aW7iuYIZpNXiphQ">REGISTER</a>
                <a href = "mailto:mizzoumca@gmail.com">CONTACT</a>
                <a href = "https://mca.missouri.edu/">MCA</a>
            </div>
        </div>
    )
}